import React from 'react'
import { Typography, Button, Divider } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import utilityConfig from 'app/configs/utilityConfigs'

const useStyles = makeStyles((theme) => ({
  Title: {
    fontSize: '20px',
    color: theme.palette.negative.main,
  },
  ContentFont: {
    fontSize: '13px',
  },
  MainContent: {
    fontSize: '13px',
    padding: '20px',
    borderWidth: '1px',
    borderRadius: '1px',
    borderColor: theme.palette.negative.main,
    background: theme.palette.background.errorLight,
    color: theme.palette.negative.main,
  },
  Header: {
    color: theme.palette.primary.main,
  },
  Or: {
    color: theme.palette.primary.subtitle,
  },
  Link: {
    color: theme.palette.secondary.main,
    marginLeft: 8,
  },
  linkEmail: {
    color: `${theme.palette.textHighlight.main} !important`,
  },
  alignSelfCenter: {
    alignSelf: 'center',
  },
}))

export default ({ reason, onClose }) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()
  return (
    <div className="flex flex-col m-36" align="center">
      <Typography className={clsx(classes.Title, 'mb-8')}>
        <FormattedMessage id="suspended.title" />
      </Typography>
      <Typography className={clsx(classes.ContentFont, 'mb-36')}>
        <FormattedMessage id="suspended.subTitle" />
      </Typography>
      <div
        variant="outlined"
        className={clsx(
          classes.MainContent,
          classes.alignSelfCenter,
          'flex flex-col justify-center w-full sm:w-1/2',
        )}
      >
        {reason || (
          <Typography>
            <FormattedMessage id="suspended.main.content" />
          </Typography>
        )}
      </div>

      <div className="flex flex-row flex-wrap w-full my-8 text-center mt-36">
        <Typography className="flex-1 flex-shrink align-middle self-center">
          {formatMessage(
            {
              id: 'suspended.footer',
            },
            {
              linkEmail: (
                <a
                  href={`mailto:${utilityConfig.supportUrl}`}
                  className={clsx(classes.linkEmail, 'ltr:pl-4 rtl:pr-4')}
                >
                  {utilityConfig.supportUrl}
                </a>
              ),
            },
          )}
        </Typography>
      </div>

      <div
        className={clsx(
          classes.alignSelfCenter,
          `w-1/2 flex flex-row items-center mt-16`,
        )}
      >
        <Divider
          className={clsx(classes.secondaryDivider, 'flex-grow')}
          color="secondary"
        />
        <Typography
          variant="subtitle1"
          color="secondary"
          className={clsx(classes.Or, 'h5 mx-16 uppercase')}
        >
          <FormattedMessage id="forgot.or" />
        </Typography>
        <Divider className={clsx(classes.secondaryDivider, 'flex-grow')} />
      </div>

      <div className="flex flex-row flex-wrap w-full my-8 text-center mt-8">
        <Typography className="flex-1 flex-shrink align-middle self-center">
          <FormattedMessage id="forgot.signInFirstPart" />
          <Button className="normal-case" color="secondary" onClick={onClose}>
            <FormattedMessage id="forgot.signInTwoPart" />
          </Button>
        </Typography>
      </div>
    </div>
  )
}
